<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box no-display" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar no-display" flat dense>
                <v-toolbar-title>
                    <strong> Subject Remark Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined persistent-hint
                        hint="Please select academic year" @change="getStd()" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list"
                        item-text="sem" item-value="id" label="Semester" persistent-hint
                        hint="Please select semester" />
                </v-col>


                <v-col cols="12" sm="2" md="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="
                            getDiv();

                        " persistent-hint hint="Please select standard" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" item-value="div_off_id"
                        :items="div_list" item-text="div_name" label="Division" outlined persistent-hint
                        hint="Please select division" @change="
                            getStudent();" />
                </v-col>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete v-model="registration_no" rounded color="#0F2027" :items="stud_list"
                        label="Select Student" item-text="name" item-value="lid" outlined dense @click="show = false"
                        persistent-hint hint="Please select Student" />
                </v-col>
                      <v-col cols="12" sm="2" md="2">
    <v-icon color="error">*</v-icon>
    <v-autocomplete
        rounded
        dense
        v-model="principal"
        :items="principal_list"
        item-text="displayName"
        item-value="displayName"
        label="Principal"
        outlined
        color="#0F2027"
        persistent-hint
        hint="Please select principal"
    ></v-autocomplete>
</v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data">
                    <v-btn class="mt-6 button" :loading="fecth_gen_btn_loader" @click="getreport()">Fetch / Generate
                    </v-btn>
                </v-col>
            </v-row>
        </v-card>
        <div style="background-color: white;">
            <v-row v-if="learnermarksheet_list && learnermarksheet_list.length > 0" class="no-display pt-4 px-4">
                <v-col cols="12" class="text-right">
                    <v-btn color="success" @click="printReport">
                        <v-icon left>mdi-printer</v-icon> Print Report
                    </v-btn>
                </v-col>
            </v-row>
            <div v-if="learnermarksheet_list && learnermarksheet_list.length > 0">
                <div v-for="(student, index) in learnermarksheet_list" :key="index" class="report-page"
                    :class="{ 'pagebreak': index > 0, 'first-page-print': index === 0 }">

                    <!-- Header -->
                    <div class="d-flex align-center text-center mb-4">
                        <div style="width: 100px;">
                            <img :src="student.org_basic_data.trust_logo" alt="Logo" style="width: 100%;">
                        </div>
                        <div class="flex-grow-1">
                            <h4 class="font-weight-regular mb-2">{{ student.org_basic_data.trust_name }}</h4>
                            <h2>{{ student.org_basic_data.school_name }}</h2>
                            <h5 class="font-weight-regular mt-3">{{ student.org_basic_data.address }} | Phone: {{
                                student.org_basic_data.phone }}</h5>
                        </div>
                    </div>
                    <hr style="border: 1px solid black; margin-bottom: 15px;" />

                    <div class="mb-4 top-info" style="line-height: 1.8; font-size: 16px;">
                        <div class="d-flex justify-space-between">
                            <div>
                                <div><b>Exam Session :</b> {{ student.ay || (sel_ay_data ? sel_ay_data.ay : '') }}</div>
                                <div><b>Student Name / विद्यार्थ्यांचे नाव :</b> {{ student.name }}</div>
                                <div><b>Standard (Class) / वर्ग :</b> {{ student.standard_name }}</div>
                            </div>

                            <div class="text-right" style="align-content: flex-end;">
                                <div><b>Section / तुकडी :</b> {{ student.div }}</div>
                                <div><b>Exam Roll No. / हजेरी क्र. :</b> {{ student.roll_no }}</div>
                            </div>
                        </div>
                    </div>

                    <!-- Remarks Table -->
                    <table v-if="sem_name == 'Annual'"
                        style="width: 100%; border-collapse: collapse; margin-bottom: 40px;">
                        <thead>
                            <tr>
                                <th style="width: 20%; padding: 7px;">Subject / विषय</th>
                                <th style="width: 40%;">Student Remark / वर्णनात्मक नोंदी ({{
                                    student.semester1_display_name
                                    || 'सत्र 1' }})</th>
                                <th style="width: 40%;">Student Remark / वर्णनात्मक नोंदी ({{
                                    student.semester2_display_name
                                    || 'सत्र 2' }})</th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Loops through the leraner_marksheet object -->
                            <tr v-for="(remark, subjKey) in student.leraner_marksheet" :key="subjKey">
                                <td style="padding: 5px;">{{ subjKey }}</td>
                                <td v-for="(sem1, index1) in remark[0] || []" :key="index1">
                                    <center>{{ sem1.comment }}</center>
                                </td>
                                <td v-for="(sem2, index2) in remark[1] || []" :key="index2">
                                    <center>{{ sem2.comment }}</center>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table v-else style="width: 100%; border-collapse: collapse;">
                        <thead>
                            <tr>
                                <th style="width: 20%;padding: 7px; text-align: center;">Subject / विषय</th>
                                <th style="width: 40%; text-align: center;">Student Remark / वर्णनात्मक नोंदी ({{
                                    student.sem_display_name }})
                                </th>
                            </tr>
                        </thead>
                      
                     
                        <tbody>
                            <tr
                                v-for="(remark, subjKey) in student.leraner_marksheet"
                                :key="subjKey"
                            >
                                <td style="padding: 10px;">
                                    {{ subjKey }}
                                </td>

                                <td>
                                    <span
                                        v-for="(com, index) in (remark[0] || [])"
                                        :key="index"
                                    >
                                        {{ com.comment }}
                                    </span>
                                </td>
                            </tr>
                        </tbody>


                    </table>

                    <!-- Footer Signatures and Date -->
                    <div class="report-footer">
                        <div class="d-flex justify-space-between align-end" style="font-size: 16px; font-weight: bold;">
                            <!-- Class Teacher -->
                            <div class="text-left">
                                <div class="signature-space">
                                    <img v-if="student.inst_sign" :src="student.inst_sign" alt="Class Teacher Signature"
                                        class="signature-image" />
                                </div>
                                <div>Class Teacher / वर्गशिक्षक</div>
                                <div class="signature-name">
                                    ( {{ student.inst_name }} )
                                </div>
                            </div>

                            <!-- Headmaster -->
                            <div class="text-right">
                                <div class="signature-space">
                                    <img v-if="student.headmaster_sign" :src="student.headmaster_sign"
                                        alt="Headmaster Signature" class="signature-image" />
                                </div>
                                <div>Headmaster / मुख्याध्यापक</div>
                               <div class="signature-name">
                                    ( {{ formatPrincipalName(principal || student.headmaster_name || signing_authority_name) }} )
                                </div>
                            </div>
                        </div>

                        <div class="report-date">
                            Date Time: {{ currentDate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import "jspdf-autotable";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            default_value: [],
            overlay: false,
            selected: [],
            snackbar: false,
            search: "",
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            semester_list: null,
            sem: null,
            sel_ay_data: null,
            fetch_loader: false,
            show: false,
            stud_list: [],
            registration_no: null,
            awspath: "",
            assessment_detail_list: [],
            principal_list: [],
            asd: null,
            role: null,
            std_div_list: null,
            div_list: null,
            div: null,
            sem: null,
            sel_std_data: null,
            fecth_gen_btn_loader: false,
            orgid: null,
            learnermarksheet_list: [],
            sem_name: null,
            currentDate: new Date().toLocaleString('en-GB', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
            }),
        };
    },

    methods: {

        async getreport() {
            const data = {
                lid: this.registration_no,
                ay: this.sel_ay_data.ay_id,
                std: this.sel_std_data.std_id,
                div: this.div,
                sem: this.sem,
                principal: this.principal
            };
            this.overlay = true;
            axios
                .post("/DataMigration/getSubjectWiseRemarkData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.learnermarksheet_list = res.data.learnermarksheet_list;
                        this.sem_name = res.data.sem_name;
                        this.overlay = false;
                        if (res.data.signing_authority_name) {
                            this.signing_authority_name = res.data.signing_authority_name;
                        }
                    }
                    else if (res.data.flag == "NO") {
                        this.showSnackbar("#b71c1c", res.data.msg_flag); // show snackbar
                        this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    this.overlay = false;
                })
                .finally(() => { });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getStudent() {
            this.role = sessionStorage.getItem("para_role");
            const data = {
                ay: this.sel_ay_data.ay_id,
                div: this.div,
                std: this.sel_std_data.std_id,
                role: this.role,
            };
            axios
                .post("/sanjivaniExamination/getAllStudents_for_marksheet", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;

                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong...");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        onload() {
            axios
                .post("/sanjivaniExamination/get_ay_std_divall")
                .then((res) => {
                    this.ay_std_div_list = res.data.data;
                    this.semester_list = res.data.semester_list
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => { });
        },

        getStd() {
            this.std_div_list = null;
            this.sel_std_data = null;
            this.div_list = null;
            this.div = null;
            this.std_div_list = this.sel_ay_data.std_list;
        },
        getPricipalList() {
            axios
                .post("Certificate/getPrincipalList")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.principal_list = (res.data.principal_list || []).map(item => {
                            const cleanName = item.name && item.name.includes(":") 
                                ? item.name.split(":")[1].trim() 
                                : item.name;
                            return {
                                ...item,
                                displayName: cleanName,
                                rawValue: item.name // keeps original in case backend needs the ID/code
                            };
                        });
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("#b71c1c", "Something went wrong while fetching principals!");
                });
        },
        getDiv() {
            this.div_list = this.sel_std_data.div_list;
            if (this.div_list.length == 0) {
                alert("No division found!!!");
                this.div_list = null;
            }
        },
        printReport() {
            this.currentDate = new Date().toLocaleString('en-GB', {
                day: '2-digit', month: '2-digit', year: 'numeric',
                hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
            });
            window.print();
        },
          formatPrincipalName(val) {
        if (!val) return "";
        // If it contains ':', take only the name after the colon
        return val.includes(":") ? val.split(":")[1].trim() : val.trim();
    },
    },

    mounted() {
        this.onload();
        this.getPricipalList();
        this.awspath = localStorage.getItem("awspath");
        this.orgid = localStorage.getItem("EPS-org-id");
    },
};
</script>
<style scoped>
tr,
td,
th {
    border: 1px solid black;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid black;
    border: 1px solid black;
    font-size: small;
}

.report-page {
    font-size: 16px;
    line-height: 1.6;
}

.report-page h4 {
    font-size: 20px !important;
}

.report-page h2 {
    font-size: 26px !important;
}

.report-page p {
    font-size: 15px !important;
}

.report-page table,
.report-page .v-data-table {
    font-size: 15px;
}

.report-page th {
    font-size: 15px !important;
    font-weight: bold;
}

.report-page td {
    font-size: 15px !important;
}

.signature-space {
    min-height: 60px;
    height: auto;
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    overflow: visible; /* Prevents clipping */
}

.signature-image {
    max-width: 180px !important;
    width: auto !important;
    max-height: 60px !important;
    height: auto;
    object-fit: contain;
    display: block;
}

.signature-name {
    font-weight: normal;
    font-size: 14px;
    margin-top: 5px;
}

.report-date {
    margin-top: 30px;
    font-size: 14px;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

@media print {
    .report-page {
        display: flex !important;
        flex-direction: column;
        min-height: 14.5in;
        box-sizing: border-box;
        font-size: 16px !important;
    }

    .first-page-print {
        margin-top: -80px !important;
    }

    .pagebreak {
        page-break-before: always;
        break-before: page;
    }

    .report-page h4 {
        font-size: 22px !important;
    }

    .report-page h2 {
        font-size: 31px !important;
    }

    .report-page h5 {
        font-size: 18px !important;
    }

    .top-info {
        font-size: 20px !important;
    }

    .report-footer {
        margin-top: auto;
        padding-top: 30px !important;
        width: 100%;
        flex-shrink: 0;
        font-size: 20px !important;
    }

    .report-footer .text-left>div,
    .report-footer .text-right>div {
        font-size: 20px !important;
    }

    .report-footer .signature-name {
        font-size: 17px !important;
    }

    .report-footer .report-date {
        font-size: 18px !important;
    }

    .signature-space {
        min-height: 60px !important;
        height: auto !important;
        overflow: visible !important;
    }

    .signature-image {
        max-width: 180px !important;
        max-height: 60px !important;
        height: auto !important;
        object-fit: contain !important;
    }

    .report-page table {
        width: 100%;
        border-collapse: collapse;
    }

    .report-page th,
    .report-page td {
        border: 1px solid black !important;
        padding: 12px !important;
        font-size: 19px !important;
    }

    .report-page img {
        max-width: 100%;
    }

    header,
    footer,
    nav,
    date {
        display: none !important;
    }

    table,
    td,
    tr {
        break-inside: avoid-page;
    }

    img {
        width: 100% !important;
    }

    body,
    tr,
    th,
    td {
        font-size: large !important;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    @page {
        size: A4;
        margin-bottom: 0;
        padding-top: none;
        size: 11in 15.5in;
    }

    thead {
        font-weight: bold !important;
    }

    table,
    td,
    tr,
    th {
        text-align: center !important;
        margin-top: none;
        padding: none !important;
        border-bottom: 1px solid black;
        border: 1px solid black;
    }
}
</style>
